import { gql } from '@apollo/client';

export const OPEN_ACCOUNT_FIELDS = gql`
  fragment OpenAccountFields on OpenAccount {
    id
    folio_number
    branch_id
    customer_id
    pet_id
    kind
    opened_by
    closed_by
    status
    balance_cents
    opened_at
    closed_at
    close_reason
    notes
    tutor_name
    pet_name
    created_at
    updated_at
  }
`;

export const OPEN_ACCOUNT_MOVEMENT_FIELDS = gql`
  fragment OpenAccountMovementFields on OpenAccountMovement {
    id
    open_account_id
    kind
    amount_cents
    balance_after_cents
    status
    reference_kind
    reference_id
    note
    cancelled_at
    cancelled_by
    cancel_reason
    created_at
    created_by
  }
`;

export const OPEN_ACCOUNT_DETAIL_QUERY = gql`
  ${OPEN_ACCOUNT_FIELDS}
  ${OPEN_ACCOUNT_MOVEMENT_FIELDS}
  query OpenAccountDetail($id: ID!) {
    openAccountDetail(id: $id) {
      account {
        ...OpenAccountFields
      }
      tutor_name
      pet_name
      pet_species
      pet_sex
      pet_breed
      pet_approximate_age_months
      last_current_weight_grams
      last_weight_measured_at
      total_charged_cents
      total_paid_cents
      balance_cents
      concepts {
        sale_order_id
        sale_folio_number
        sale_order_item_id
        line_no
        item_kind
        item_code
        item_name
        quantity
        unit_price_cents
        total_cents
        covered_cents
        pending_cents
        coverage_status
        charged_at
      }
      charges {
        sale_order_id
        sale_folio_number
        total_cents
        paid_cents
        pending_cents
        status
        charged_at
      }
      abonos {
        payment_id
        payment_folio_number
        payment_method_id
        payment_method_code
        payment_method_name
        amount_cents
        reference_number
        captured_at
      }
      movements {
        ...OpenAccountMovementFields
      }
    }
  }
`;

export const OPEN_ACCOUNTS_QUERY = gql`
  ${OPEN_ACCOUNT_FIELDS}
  query OpenAccounts(
    $offset: Int
    $limit: Int
    $search: String
    $customer_id: ID
    $pet_id: ID
    $kind: OpenAccountKind
    $kinds: [OpenAccountKind!]
    $status: OpenAccountStatus
    $branch_id: ID
  ) {
    openAccounts(
      offset: $offset
      limit: $limit
      search: $search
      customer_id: $customer_id
      pet_id: $pet_id
      kind: $kind
      kinds: $kinds
      status: $status
      branch_id: $branch_id
    ) {
      items {
        ...OpenAccountFields
      }
      page {
        total
        offset
        limit
        has_more
      }
    }
  }
`;

export const OPEN_ACCOUNT_QUERY = gql`
  ${OPEN_ACCOUNT_FIELDS}
  query OpenAccount($id: ID!) {
    openAccount(id: $id) {
      ...OpenAccountFields
    }
  }
`;

export const OPEN_ACCOUNT_MOVEMENTS_QUERY = gql`
  ${OPEN_ACCOUNT_MOVEMENT_FIELDS}
  query OpenAccountMovements($open_account_id: ID!) {
    openAccountMovements(open_account_id: $open_account_id) {
      ...OpenAccountMovementFields
    }
  }
`;

export const ACTIVE_OPEN_ACCOUNT_QUERY = gql`
  ${OPEN_ACCOUNT_FIELDS}
  query ActiveOpenAccount($customer_id: ID!, $pet_id: ID!, $kind: OpenAccountKind) {
    activeOpenAccount(customer_id: $customer_id, pet_id: $pet_id, kind: $kind) {
      ...OpenAccountFields
    }
  }
`;

export const CREATE_OPEN_ACCOUNT_MUTATION = gql`
  ${OPEN_ACCOUNT_FIELDS}
  mutation CreateOpenAccount($input: CreateOpenAccountInputGql!) {
    createOpenAccount(input: $input) {
      ...OpenAccountFields
    }
  }
`;

export const APPLY_ABONO_MUTATION = gql`
  ${OPEN_ACCOUNT_FIELDS}
  ${OPEN_ACCOUNT_MOVEMENT_FIELDS}
  mutation ApplyAbono($input: ApplyAbonoInputGql!) {
    applyAbono(input: $input) {
      account {
        ...OpenAccountFields
      }
      movements {
        ...OpenAccountMovementFields
      }
      payment_ids
      ticket_id
      ticket_folio_number
      balance_before_cents
      balance_after_cents
      covered_concepts {
        sale_order_id
        sale_folio_number
        sale_order_item_id
        line_no
        item_kind
        item_code
        item_name
        quantity
        unit_price_cents
        total_cents
        covered_cents
        pending_cents
        coverage_status
        charged_at
      }
    }
  }
`;

export const ADD_OPEN_ACCOUNT_CONCEPTS_MUTATION = gql`
  mutation AddOpenAccountConcepts($input: AddOpenAccountConceptsInputGql!) {
    addOpenAccountConcepts(input: $input) {
      id
      folio_number
      status
      total_cents
      pending_cents
      open_account_id
    }
  }
`;

export const SETTLE_OPEN_ACCOUNT_MUTATION = gql`
  ${OPEN_ACCOUNT_FIELDS}
  mutation SettleOpenAccount($input: SettleOpenAccountInputGql!) {
    settleOpenAccount(input: $input) {
      ...OpenAccountFields
    }
  }
`;

export const CANCEL_LAST_OPEN_ACCOUNT_MOVEMENT_MUTATION = gql`
  ${OPEN_ACCOUNT_FIELDS}
  mutation CancelLastOpenAccountMovement($input: CancelLastOpenAccountMovementInputGql!) {
    cancelLastOpenAccountMovement(input: $input) {
      ...OpenAccountFields
    }
  }
`;
